<template>
  <div>
    <component :is="componentLoader"></component>
    <show-activities />
  </div>
</template>

<script>
import store from '@/store/store';
import ShowActivities from '@/views/WorkExperiences/components/ShowActivities';

export default {
  components: { ShowActivities },
  computed: {
    componentLoader() {
      const loginType = localStorage.getItem('login_type');
      let experience = null;
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        experience = experiences.find((i) => i.id == this.$route.params.id);
      } else {
        experience = store.getters['authTeacher/experience'];
      }
      if (experience != null && experience.vje.folder_name != 'real_world_experience')
        return () =>
          import('@/views/WorkExperiences/' + experience.vje.folder_name + '/Activities.vue');
    },
  },
};
</script>
